// https://alidocs.dingtalk.com/i/nodes/G1DKw2zgV2RNLDK9FAmNYYmPVB5r9YAn?corpId=

export const GOODS_RULE_OPERATE_V2 = 'GOODS_RULE_OPERATE_V2' // 运营中心白名单
export const ERP_AFTERSALE_BIGSHOP_AUTO = 'ERP_AFTERSALE_BIGSHOP_AUTO' // 售后-退款单、售后详情、售后单导入 区分跳erp白名单
export const NEW_AFTER_SALES_ISSUE_REGISTRATION_WHITELIST = 'NEW_AFTER_SALES_ISSUE_REGISTRATION_WHITELIST' // 售后问题登记分类白名单
export const REFUND_ONLY_ORDER_STATUS_WHITELIST = 'REFUND_ONLY_ORDER_STATUS_WHITELIST' // 售后自动化-未发货仅退款 erp订单状态、面单打印、订单实付白名单
export const ALLOW_NEGATIVE_DEDUCTION_WHITE_LIST = 'ALLOW_NEGATIVE_DEDUCTION_WHITE_LIST' // 设置运费允许为负数配置开关
export const DY_GOODS_SIZE_VALIDATE_WHITE_LIST = 'DY_GOODS_SIZE_VALIDATE_WHITE_LIST' // 新的抖音尺码校验

/** 我的供应商-供应商售后地址，支持大店可编辑 */
export const AFTER_SALE_ADDRESS_MIDDLEMAN = 'AFTER_SALE_ADDRESS_MIDDLEMAN'
export const AFTER_SALE_SCM_INTERCEPT_LOGISTICS = 'AFTER_SALE_SCM_INTERCEPT_LOGISTICS' // 快递拦截一期
export const SHIPPED_REFUND_ONLY_AUTOMATION_WHITE_LIST_V1 = 'SHIPPED_REFUND_ONLY_AUTOMATION_WHITE_LIST_V1'
export const SUP_DIS_COMBINATION_PACKAGE_SELLER_COMPENSATION_WHITELIST =
    'SUP_DIS_COMBINATION_PACKAGE_SELLER_COMPENSATION_WHITELIST' // 极速退款确认
export const AFTERSALE_SUPPLIER_REISSUE_WHITE_LIST = 'AFTERSALE_SUPPLIER_REISSUE_WHITE_LIST' // 供应商创建补发售后单
export const ONLINE_REFUND_WITHDRAWAL_WHITELIST = 'ONLINE_REFUND_WITHDRAWAL_WHITELIST' // 撤回推单是否优先在线退款的白名单
export const AFTER_SALE_ADDRESS_COMPARISON_WHITE_LIST = 'AFTER_SALE_ADDRESS_COMPARISON_WHITE_LIST' // 退错地址的白名单
export const ORDER_JD_DECRYPTION_WHITELIST = 'ORDER_JD_DECRYPTION_WHITELIST' // 京东解密白名单
export const AFTERSALE_PUSH_TO_QIMEN_WHITE_LIST = 'AFTERSALE_PUSH_TO_QIMEN_WHITE_LIST' // 售后-自动化推送奇门
export const SEARCH_STOCK_BLOCK = 'SEARCH_STOCK_BLOCK' // 只看有货按钮 黑名单
export const DOU_YIN_SPU_MANAGE = 'DOU_YIN_SPU_MANAGE' // 是否具有新建SPU权限白名单
export const SMALL_PAY_WHITE_LIST = 'SMALL_PAY_WHITE_LIST' // 小额赔付白名单
export const DRP_RULE_MERGE = 'DRP_RULE_MERGE' // 分销规则白名单
export const GOODS_WECHAT_NOTIFY_COID = 'GOODS_WECHAT_NOTIFY_COID' // 订阅公众号白名单
export const HOT_GOODS_PRIVILEGE = 'HOT_GOODS_PRIVILEGE' // 优质分销商白名单
export const PENDING_ORDERS_BY_SUPPLIER_COUNT = 'PENDING_ORDERS_BY_SUPPLIER_COUNT' // 推单异常按照供应商白名单
export const BATCH_UPDATE_DIS_PRICE_WHITE_LIST = 'BATCH_UPDATE_DIS_PRICE_WHITE_LIST' // 小站修改1-5级供货价白名单
export const SHOW_CURRENT_ARREARS_COIDS = 'SHOW_CURRENT_ARREARS_COIDS' // 分销资金明细是否显示当前欠款白名单

/** 售后自动化-京东自动同意退款白名单 */
export const JD_AUTO_REFUND = 'JD_AUTO_REFUND'

export default [GOODS_RULE_OPERATE_V2, DOU_YIN_SPU_MANAGE]

/** 售后自动化-支持1688白名单 */
export const AFTERSALE_AUTO_ALIBABA = 'AFTERSALE_AUTO_ALIBABA'
/** 售后自动化-支持拼多多白名单 */
export const AFTER_SALE_PDD_AUTO_REFUND_WHITE_LIST = 'AFTER_SALE_PDD_AUTO_REFUND_WHITE_LIST'

export const GOODS_DRAFT_STATUS = 'GOODS_DRAFT_STATUS' // 商品草稿状态白名单

export const ACCESS_PRE = 'ACCESS_PRE' // 只有这些用户才允许在pre环境

/** 支持供应商配置自动退款给分销商策略，实现售后退款自动化白名单 */
export const SUPPLIER_AUTO_REFUND = 'SUPPLIER_AUTO_REFUND'

export const INSIDER_COID_LIST = 'INSIDER_COID_LIST' // 同DRP_SUPP_AUTOSPLIT ｜HOT_GOODS_PRIVILEGE，两个白名单key任意一个为true，都可以
export const ORDER_GUIDE_WHITELIST_MASTER_SLAVE = 'ORDER_GUIDE_WHITELIST_MASTER_SLAVE' // 订单列表判断是否数据为空时的白名单，用来请求接口的参数
export const PURCHASE_AMOUNT_SHARDING_WHITELIST = 'PURCHASE_AMOUNT_SHARDING_WHITELIST' // 订单列表采购金额为分步加载，是否请求

export const ASYNC_AUDIT_ORDER_WHITE_LIST = 'ASYNC_AUDIT_ORDER_WHITE_LIST' // 订单推单审核优化-是否开启异步
export const DAREN_BELONG_AUTO_RELEASE_WHITELIST = 'DAREN_BELONG_AUTO_RELEASE_WHITELIST' // 达人：支持设置将达人自动释放回公司达人库（白名单）

export const UNDERPRICED_ORDER_WHITELIST = 'UNDERPRICED_ORDER_WHITELIST' // 当日破价订单
export const CHANNEL_CUSTOMER_CENTER_DIY_DATE = 'CHANNEL_CUSTOMER_CENTER_DIY_DATE' // 分销客户中心自定义时间
/**
 * 售后极速版支持查看IPC视频功能
 */
export const AFTER_SALE_IPC_OPEN_V2 = 'AFTER_SALE_IPC_OPEN_V2'
export const AFTER_SALE_IPC_OPEN_MERGE = 'AFTER_SALE_IPC_OPEN_MERGE'
export const GOODS_POOL_WEIGHT_DETAILS_WHITE_LIST = 'GOODS_POOL_WEIGHT_DETAILS_WHITE_LIST' // 找商品权重

/** 优先在线退款的白名单 */
export const PAY_REFUND_ONLINE_SUFFIX_WHITELIST = `PAY_REFUND_ONLINE_SUFFIX_WHITELIST`

/** 起采金额白名单 */
export const MIN_PURCHASE_COIDS = 'MIN_PURCHASE_COIDS'

/** 商品运营分析按sku粒度补货 */
export const GOODS_RULE_OPERATE_SKU_REPLENISHMENT = 'GOODS_RULE_OPERATE_SKU_REPLENISHMENT'

/** 异步处理售后操作（退货退款、仅退款）白名单 */
export const AFTER_SALES_RETURN_ASYNC_WHITELIST = 'AFTER_SALES_RETURN_ASYNC_WHITELIST'

/** erp预售库存白名单 */
export const DOUYIN_TIME_SALE_STOCK = 'DOUYIN_TIME_SALE_STOCK'

// 分销规则分销商标签
export const POLICY_CHANNEL_LABEL_WHITE_LIST = 'POLICY_CHANNEL_LABEL_WHITE_LIST'
/** 免费版禁止预充值-免费版系统公告白名单 **/
export const FREE_SUPPLIER_FORBID_RECHARGE_SYSTEM_NOTICE_WHITE_LIST =
    'FREE_SUPPLIER_FORBID_RECHARGE_SYSTEM_NOTICE_WHITE_LIST'

export const CONFIRM_RECEIPT_EXCLUDE_GIFT_WHITELIST = 'CONFIRM_RECEIPT_EXCLUDE_GIFT_WHITELIST'

/** 分销服务费白名单 */
export const PUSH_ORDER_COMMERCIALIZE_WHITELIST = 'PUSH_ORDER_COMMERCIALIZE_WHITELIST'

/** 分销资金明细导出日志白名单 */
export const EXPORT_MULTI_COMPANY = 'EXPORT_MULTI_COMPANY'

/** 抖音极速铺货 */
export const PC_SHELVES_DY_FAST_PERFECT_TEMPLATE = 'PC_SHELVES_DY_FAST_PERFECT_TEMPLATE'

/** AI预测商品资料 */
export const FORECAST_PLATFORM_WHITE_LIST = 'FORECAST_PLATFORM_WHITE_LIST'

/** 抖音新版类目编辑及强控白名单 */
export const DY_NEW_CATEGORY_EDIT_AND_FORCED_CONTROL = 'DY_NEW_CATEGORY_EDIT_AND_FORCED_CONTROL'

/** 抖音新版类目 允许修改类目白名单 */
export const DY_ALLOW_MODIFY_CATEGORY = 'DY_ALLOW_MODIFY_CATEGORY'

/** 同步线上发货失败 白名单key  */
export const ORDER_SYNC_ONLINE_DELIVERY_FAIL_WHITE = 'ORDER_SYNC_ONLINE_DELIVERY_FAIL_WHITE'
/** 同步线上发货失败 黑名单key */
export const ORDER_SYNC_ONLINE_DELIVERY_FAIL_BLACK = 'ORDER_SYNC_ONLINE_DELIVERY_FAIL_BLACK'

/** 抖音多退款地址 */
export const UPLOAD_SHOP_RETURN_ADDRESS_WHEN_STOCKING_WHITELIST = 'UPLOAD_SHOP_RETURN_ADDRESS_WHEN_STOCKING_WHITELIST'

/** 自动上传供应商退货地址 */
export const DRP_SEND_UPLOAD_AFS_ADDRESS = 'DRP_SEND_UPLOAD_AFS_ADDRESS'

/** 售后：支持按「售后分类」设置供应商扣款规则，且支持大店商品详情透出扣款规则，提升售后处理效率(白名单 */
export const AFTER_SALE_SUP_DEDUCTION_RULE = 'AFTER_SALE_SUP_DEDUCTION_RULE'

/** 推单支付支付弹窗中，金额输入框仅展示值不可编辑 */
export const PUSH_ORDER_FORBID_EDIT_AMOUNT = 'PUSH_ORDER_FORBID_EDIT_AMOUNT'

export const FIND_DAREN_WHITELIST = 'FIND_DAREN_WHITELIST' // 达人管理白名单

export const PRINTER_INOUT_LIST_5000_WHITELIST = 'PRINTER_INOUT_LIST_5000_WHITELIST' // 打单-待发货 分页允许 5000/条

// 分销版关闭打单拣货界面提示:
export const PRINTER_CLOSE_PROMT_WHITE_LIST = 'PRINTER_CLOSE_PROMT_WHITE_LIST'
// 分销版关闭打单拣货界面:
export const PRINTER_CLOSE_WHITE_LIST = 'PRINTER_CLOSE_WHITE_LIST'

export const ORDER_DRP_ZPLAN_SETLC_REFREIGHT = 'ORDER_DRP_ZPLAN_SETLC_REFREIGHT'
/**
 * 推单支付-单笔/多笔支付流程优化，简化推单支付流程
 */
export const PAY_UNIFIED_CREATE_ORDER_SUFFIX_WHITELIST = 'PAY_UNIFIED_CREATE_ORDER_SUFFIX_WHITELIST'

export const AUTONOMY_SYNC_PLATFORM_CATE_WHITE = 'AUTONOMY_SYNC_PLATFORM_CATE_WHITE' // 支持商家自主获取平台缺失类目信息

export const SHOP_PUBLISH_WHITELIST = 'SHOP_PUBLISH_WHITELIST' //  快手打单版，暂不支持发品

export const CUSTOMER_CHAT_NEW_VERSION = 'CUSTOMER_CHAT_NEW_VERSION' // 客服聊天白名单
export const KS_SHELVES_SUPPORT_VIDEO = 'KS_SHELVES_SUPPORT_VIDEO'
export const FORCAST_CATEGORY_WITH_IMAGE = 'FORCAST_CATEGORY_WITH_IMAGE'

export const USE_SYSTEM_FORCAST_CATEGORY = 'USE_SYSTEM_FORCAST_CATEGORY'

// 分销商推单给供应商，支持优先执行订单预处理规则再执行佣金规则，避免佣金规则不生效（白名单）
export const ORDER_DRP_PRIORITY_FILTERRULE = 'ORDER_DRP_PRIORITY_FILTERRULE'
export const DRP_ORDER_ENCRYPT_WHITE_LIST = 'DRP_ORDER_ENCRYPT_WHITE_LIST'

// 打单-脱敏配置白名单:
export const PRINTER_SENSITIVE_WHITELIST = 'PRINTER_SENSITIVE_WHITELIST'
/** https://devops.aliyun.com/projex/req/JSTGYL-40690# 《达人库搭建：采集并补全「快手/视频号/小红书」达人库信息，并支持周期性更新数据》 */
export const MARKET_DAREM_ALL_PLATFORM_INFO_SHOW_SUFFIX_WHITELIST =
    'MARKET_DAREM_ALL_PLATFORM_INFO_SHOW_SUFFIX_WHITELIST'
